import { makeAuthenticatedRequest } from './api';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

/**
 * Fetches the current user's info from the backend.
 * @returns {Promise<object>} - The user info object from /auth/user-info
 * @throws {Error} - Throws if the request fails or user is not authenticated
 */
export const fetchUserInfo = async () => {
  try {
    const result = await makeAuthenticatedRequest('/auth/user-info', { method: 'POST' });
    console.log('Backend /auth/user-info response:', result);
    return result;
  } catch (error) {
    console.error('Error calling /auth/user-info:', error);
    throw error;
  }
};

/**
 * Signs out the current Firebase user.
 */
export const signOutFirebase = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    // Ignore sign out errors
  }
};
